import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconMinus48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="50"
            height="48"
            viewBox="0 0 50 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="minus">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.958307 23L49.0416 23L49.0416 25L0.958308 25L0.958307 23Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconMinus24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="minus">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.686366 11L23.3138 11L23.3138 13L0.686367 13L0.686366 11Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconMinus16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="minus">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M0.92885 6.99996L15.071 6.99996L15.071 8.99996L0.928849 8.99996L0.92885 6.99996Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
